/**
 * Read a required string from import.meta.env, failing fast with a clear
 * error so missing dev/prod Vite env vars don't silently become "undefined"
 * embedded in the auth flow.
 */
function required(key: string): string {
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Missing required Vite env var ${key}. Copy web/.env.example to web/.env.local and fill it in.`,
    );
  }
  return value;
}

export const env = {
  keycloakAuthority: required('VITE_KEYCLOAK_AUTHORITY'),
  keycloakClientId: required('VITE_KEYCLOAK_CLIENT_ID'),
  appBaseUrl:
    import.meta.env.VITE_APP_BASE_URL ??
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'),
};
